import { all } from 'redux-saga/effects';
// import saga from './Redux/Sagas/saga';
import Common from './Redux/Sagas/Common';
import Inquiry from './Redux/Sagas/Inquiry';
import Issuance from './Redux/Sagas/Issuance';
import Statistics from './Redux/Sagas/Statistics';
import Management from './Redux/Sagas/Management';
import Support from './Redux/Sagas/Support';

export default function* rootSaga() {
  // yield all([...saga]);
  yield all([
    ...Common,
    ...Inquiry,
    ...Issuance,
    ...Statistics,
    ...Management,
    ...Support,
  ]);
}
